import * as Yup from "yup";
const sliderSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  desktopImg: Yup.mixed().required("Desktop image is required"),
  mobileImg: Yup.mixed().required("Mobile image is required"),
});

const counterSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  number: Yup.string().required("Number is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  desktopImg: Yup.mixed().required("Image is required"),
});

const clientSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  position: Yup.string().required("Position is required"),
  description: Yup.string().required("Description is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const blogSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  link: Yup.string().required("Link is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  thumbnailImage: Yup.mixed().required("Thumbnail image is required"),
});

const milestoneSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  year: Yup.string().required("Year is required"),
  description: Yup.string().required("Description is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const featureSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  desktopImg: Yup.mixed().required("Image is required"),
});

const categorySchema = Yup.object().shape({
  categoryName: Yup.string().required("Name is required"),
  categoryLink: Yup.string().required("Link is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const subCategorySchema = Yup.object().shape({
  subCategoryName: Yup.string().required("Name is required"),
  subCategoryLink: Yup.string().required("Link is required"),
  thumbnailImage: Yup.mixed().required("Thumbnail image is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

// const productSchema = Yup.object().shape({
//   productTitle: Yup.string().required("Title is required"),
//   productLink: Yup.string().required("Link is required"),
//   thumbnailImage: Yup.mixed().required("Thumbnail image is required"),
//   icon: Yup.mixed().required("Icon image is required"),
//   sortOrder: Yup.number().required("Sort order is required"),
// });

const faqTypeSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const faqSchema = Yup.object().shape({
  question: Yup.string().required("Question is required"),
  answer: Yup.string().required("Answer is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const productSpecificationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  subTitle: Yup.string().required("Sub Title is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  desktopImg: Yup.mixed().required("Image is required"),
});

const productColourSchema = Yup.object().shape({
  colour_code: Yup.string().required("Colour code is required"),
  colour_name: Yup.string().required("Colour name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current Password is required"),
  newPassword: Yup.string().required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const updateProfileSchema = Yup.object().shape({
  userName: Yup.string().required("Username is required"),
});

const emailTemplateSchema = Yup.object().shape({
  name:        Yup.string().required("Name is required"),
  subject:     Yup.string().required("Subject is required"),
  to:          Yup.string().email("Invalid email").nullable().notRequired(),
  cc:          Yup.string().email("Invalid email").nullable().notRequired(),
  bcc:         Yup.string().email("Invalid email").nullable().notRequired(),
  description: Yup.string().required("Description is required"),
  isActive:    Yup.bool().default(true),
});

const EmailConfigSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(8, "Minimum 8 characters")
    .required("Password is required"),
  host: Yup.string().required("SMTP host is required"),
  port: Yup.number()
    .typeError("Port must be a number")
    .required("Port is required"),
});

const projectTypeSchema = Yup.object().shape({
  projectType: Yup.string().required("Project Type is required"),
  link: Yup.string().required("Link is required"),
  thumbnailImage: Yup.mixed().required("Thumbnail image is required"),
  sortOrder: Yup.number().required("Sort order is required"),
});

const pageBuilderSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Page title is required")
    .min(3, "Title must be at least 3 characters"),
  rows: Yup.array()
    .of(
      Yup.object({
        component: Yup.string().required("Component is required"),
        cmsId: Yup.string().when("componentType", {
          is: "CMS",
          then: (schema) => schema.required("CMS selection is required"),
          otherwise: (schema) => schema.nullable(),
        }),
        sortOrder: Yup.number()
          .typeError("Sort order must be a number")
          .required("Sort order is required")
          .min(1, "Sort order must be at least 1"),
        isActive: Yup.boolean(),
      }),
    )
    .min(1, "At least one row is required"),
});

const subMenuSchema = Yup.object().shape({
  sortOrder: Yup.number()
    .typeError("Sort order must be a number")
    .required("Sort order is required")
    .min(1, "Sort order must be at least 1"),
  subMenuName: Yup.string().required("Sub Menu Name is required"),
  subMenuType: Yup.string().required("Sub Menu Type is required"),
  subMenuUrl: Yup.string().required("Sub Menu Url is required"),
  menuId: Yup.string().required("Menu Id is required"),
});

const menuSchema = Yup.object().shape({
  sortOrder: Yup.number()
    .typeError("Sort order must be a number")
    .required("Sort order is required")
    .min(1, "Sort order must be at least 1"),
  menuName: Yup.string().required("Menu Name is required"),
  menuType: Yup.string().required("Menu Type is required"),
});

const pageBannerSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  desktopImg: Yup.mixed().required("Desktop image is required"),
  description: Yup.string().required("Description is required"),
  menuId: Yup.string().required("Menu Id is required"),
});

const SocialMediaSchema = Yup.object().shape({
  sortOrder: Yup.number().required("Sort order is required"),
  name: Yup.string().required("Title is required"),
  url: Yup.string().required("Url is required"),
  desktopImg: Yup.mixed().required("Icon is required"),
});

const qualitySchema = Yup.object().shape({
  qualityName: Yup.string().required("Name is required"),
  rawMaterial: Yup.mixed().required("Raw Material is required"),
  harvest: Yup.mixed().required("Harvest is required"),
  sorting: Yup.mixed().required("Sorting is required"),
  cuppingScore: Yup.mixed().required("Cupping Score is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const packSizeSchema = Yup.object().shape({
  packSizeName: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const traceabilitySchema = Yup.object().shape({
  traceabilityName: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const packBagSchema = Yup.object().shape({
  packBagName: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const countrySchema = Yup.object().shape({
  countryName: Yup.string().required("Name is required"),
  countryCode: Yup.string().required("Country code is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const priceTypeSchema = Yup.object().shape({
  priceTypeName: Yup.string().required("Name is required"),
  priceTypeCode: Yup.string().required("Code is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const priceListSchema = Yup.object().shape({
  price: Yup.number()
    .typeError("Price must be a number")
    .min(0, "Price must be greater than or equal to 0")
    .required("Price is required"),

  country_id: Yup.string().required("Country is required"),
  priceType_id: Yup.string().required("Price Type is required"),
  category_id: Yup.string().required("Category is required"),
  quality_id: Yup.string().required("Quality is required"),
  traceability_id: Yup.string().required("Source is required"),
  packSize_id: Yup.string().required("Pack Size is required"),
  packBag_id: Yup.string().required("Pack Bag is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});

const grindSchema = Yup.object().shape({
  grindName: Yup.string().required("Name is required"),
  sortOrder: Yup.number().required("Sort order is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const productSchema = Yup.object().shape({
  productTitle: Yup.string().required("Title is required"),
  thumbnailImage: Yup.mixed().required("Thumbnail image is required"),
  productSKU: Yup.string().required("Sku is required"),
  countryIds: Yup.array().of(Yup.string()).min(1, "Country is required"),
  categoryId: Yup.string().required("Category is required"),
  isActive: Yup.bool().required("Is Active is required"),
});
const pageSchema = Yup.object({
  page: Yup.string().required("Page name is required"),
  action: Yup.array()
    .of(
      Yup.object({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
    )
    .min(1, "Please select at least one action")
    .required("Action is required"),
});

const userSchema = Yup.object().shape({
  fullName: Yup.string().required("Full Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(8, "Minimum 8 characters")
    .optional(),
});
const permissionSchema = Yup.object({
  page: Yup.object()
    .nullable()
    .required("Page name is required"),

  permission: Yup.array()
    .of(
      Yup.object({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
    )
    .min(1, "Please select at least one permission")
    .required("Permission is required"),
});
export {
  sliderSchema,
  changePasswordSchema,
  updateProfileSchema,
  emailTemplateSchema,
  EmailConfigSchema,
  counterSchema,
  clientSchema,
  blogSchema,
  milestoneSchema,
  featureSchema,
  categorySchema,
  faqSchema,
  subCategorySchema,
  productSchema,
  productSpecificationSchema,
  productColourSchema,
  projectTypeSchema,
  faqTypeSchema,
  pageBuilderSchema,
  subMenuSchema,
  menuSchema,
  pageBannerSchema,
  SocialMediaSchema,
  qualitySchema,
  packSizeSchema,
  traceabilitySchema,
  packBagSchema,
  countrySchema,
  priceTypeSchema,
  priceListSchema,
  grindSchema,
  pageSchema,
  userSchema,
  permissionSchema
};
